<template>
  <NuxtLayout
    name="radar"
    :bread-crumb-list="breadcrumb"
  >
    <template #main>
      <div class="main">
        <SectionTitle
          :title="`${areaLabelMap[areaId]}の雨雲レーダー`"
          :left-text="`日本時刻 ${now.locale(ja).format('M/D(ddd) H時')}`"
          share-category="RADAR_AREA"
          :share-title="title"
          is-h1
        />
        <MapRadar
          :now="now"
          :lat="areaId2setting[areaId].lat"
          :lon="areaId2setting[areaId].lon"
          :zoom="areaId2setting[areaId].zoom"
        />
      </div>
    </template>
    <template #main-bottom>
      <div class="main">
        <text-link
          :text="`${areaLabelMap[areaId]}の天気を見る`"
          :href="`/${areaId}/`"
        />
        <CommonCountryList is-radar />
      </div>
    </template>
  </NuxtLayout>
</template>

<script setup>
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import ja from 'dayjs/locale/ja'

dayjs.extend(utc)
dayjs.extend(timezone)

const route = useRoute()
const areaId = route.params.area
if (!areaLabelMap[areaId]) {
  throw createError({
    statusCode: 404,
    statusMessage: 'Invalid areaId'
  })
}
const areaId2setting = {
  1: {
    lat: 35,
    lon: 105,
    zoom: 2.5
  },
  2: {
    lat: 10,
    lon: 105,
    zoom: 2.5
  },
  3: {
    lat: 20,
    lon: 75,
    zoom: 2.5
  },
  4: {
    lat: 27,
    lon: 45,
    zoom: 2.5
  },
  5: {
    lat: 55,
    lon: 15,
    zoom: 2.2
  },
  6: {
    lat: -20,
    lon: 135,
    zoom: 1.8
  },
  7: {
    lat: 50,
    lon: -100,
    zoom: 1.6
  },
  8: {
    lat: -20,
    lon: -60,
    zoom: 2
  },
  9: {
    lat: 5,
    lon: 20,
    zoom: 2
  }
}

const now = dayjs().startOf('hour').tz('Asia/Tokyo')

const runtimeConfig = useRuntimeConfig()
const domain = runtimeConfig.public.hostDomain

const breadcrumb = [
  {
    text: '世界天気',
    link: `${domain}/onebox/tenki/world/`
  },
  {
    text: '雨雲レーダー 世界',
    link: `${domain}/onebox/tenki/world/radar/`
  },
  {
    text: `${areaLabelMap[areaId]}`
  }
]
const title = `${areaLabelMap[areaId]}の雨雲レーダー - ウェザーニュース`
useCommonHead({
  title,
  description: `【48時間予想の${areaLabelMap[areaId]}雨雲レーダー】リアルタイムな雨雲の動きから最大48時間先の予報まで確認できます。旅の出発前に現地の2週間天気も併せてチェック。天気・気象に関する全てのサポートは【予報精度No.1ウェザーニュース】にお任せください。`,
  keywords: `${areaLabelMap[areaId]},雨雲レーダー,48時間`,
  appTitle: areaLabelMap[areaId],
  appCountKey: route.path.toLowerCase(),
  iconUrl: `${runtimeConfig.public.gvsUrl}/onebox/img/world/icon/icon_wradar_white@2x.png`,
  iconGrayUrl: `${runtimeConfig.public.gvsUrl}/onebox/img/world/icon/icon_wradar_trans@2x.png`,
  iconSettingUrl: `${runtimeConfig.public.gvsUrl}/onebox/img/world/icon/icon_wradar@2x.png`
})
useCommonJsonld({ breadcrumb })
</script>

<style scoped>
.main {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
}
</style>
